import { observer } from 'mobx-react-lite'

import User from 'singletons/User'

import PatientCard from 'components/Dashboard/cards/Patient'
import Placeholder from 'components/Dashboard/common/Placeholder'
import VisitTypes from 'constants/visit-types'
import { useCallback } from 'react'

const getVisitVariant = (hasInProgressVisit, claimed, hasClaimedPending, isSuccess) => {
  if (isSuccess) {
    if (hasInProgressVisit) {
      return 'successAvailableDisabled'
    }

    if (claimed) {
      return 'successClaimed'
    }

    if (hasClaimedPending) {
      return 'successAvailableDisabled'
    }
    return 'successAvailable'
  }

  if (hasInProgressVisit) {
    return 'availableDisabled'
  }

  if (claimed) {
    return 'claimed'
  }

  if (hasClaimedPending) {
    return 'availableDisabled'
  }

  return 'available'
}

const Queue = () => {
  const onClaimVisit = useCallback(
    (claimFn, index) => async () => {
      await claimFn()
      if (index) {
        window.scroll(0, 0)
      }
    },
    [],
  )

  if (!User.provider) {
    return null
  }

  const {
    visitQueue: { queuedTalkNowAndMedicalVisits, queuedCrisisVisits, hasInProgressVisit, hasClaimedPending },
  } = User.provider

  if (!queuedCrisisVisits.length && !queuedTalkNowAndMedicalVisits.length) {
    return (
      <div className="flex-1 min-h-0 overflow-auto">
        <Placeholder text="There is currently no one in the Queue." icon="queue" />
      </div>
    )
  }

  return (
    <div className="flex-1 min-h-0 overflow-auto">
      {queuedCrisisVisits.map(
        (
          {
            memberFullName,
            pendingVisitId,
            age,
            fullLocation,
            claimed,
            claim,
            shouldHideClock,
            modality,
            waitTime,
            shouldShowAslInterpreterPill,
          },
          i,
        ) => (
          <PatientCard
            className="m-6"
            pendingVisitId={pendingVisitId}
            key={pendingVisitId}
            name={memberFullName}
            age={age}
            state={fullLocation}
            onClaim={onClaimVisit(claim, i)}
            variant={
              claimed ? getVisitVariant(hasInProgressVisit, claimed, hasClaimedPending, false) : VisitTypes.crisis
            }
            shouldHideClock={shouldHideClock}
            modality={modality}
            waitTime={waitTime}
            showAslPill={shouldShowAslInterpreterPill}
          />
        ),
      )}

      {queuedTalkNowAndMedicalVisits.map(
        (
          {
            memberFullName,
            pendingVisitId,
            age,
            fullLocation,
            claimed,
            claim,
            shouldHideClock,
            modality,
            waitTime,
            visitType,
            shouldShowAslInterpreterPill,
          },
          i,
        ) => (
          <PatientCard
            className="m-6"
            pendingVisitId={pendingVisitId}
            key={pendingVisitId}
            name={memberFullName}
            age={age}
            state={fullLocation}
            onClaim={onClaimVisit(claim, i)}
            variant={getVisitVariant(hasInProgressVisit, claimed, hasClaimedPending, visitType === VisitTypes.success)}
            shouldHideClock={shouldHideClock}
            modality={modality}
            waitTime={waitTime}
            showAslPill={shouldShowAslInterpreterPill}
          />
        ),
      )}
    </div>
  )
}

export default observer(Queue)
